import { Chip } from '@mui/material';
import styled from 'styled-components';

export const StyledChip = styled(Chip)`
  margin: 4px;
`;
